export const GIFT_STEP_ONE = 1
export const GIFT_STEP_TWO = 2
export const GIFT_STEP_THREE = 3
export const GIFT_STEP_FOUR = 4
export const GIFT_STEP_FIVE = 5

export const GIFT_THEME_TYPE_BIRTHDAY = 'birthday'
export const GIFT_THEME_TYPE_HOLIDAY = 'holiday'
export const GIFT_THEME_TYPE_THANKYOU = 'thankyYou'
export const GIFT_THEME_TYPE_JUST_BECAUSE = 'justBecause'
export const GIFT_THEME_TYPE_SEEKING_TRUTH = 'seekingTruth'
export const GIFT_THEME_TYPE_YOGA = 'yoga'

export const GIFT_PAYMENT_TYPE_EXISTING = 'existing'
export const GIFT_PAYMENT_TYPE_CREDIT_CARD = 'creditCard'
export const GIFT_PAYMENT_TYPE_PAYPAL = 'payPal'
